module.exports = __webpack_public_path__ + "static/media/people.b6c21e59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people.png
// module id = 1288
// module chunks = 0